module.exports = __webpack_public_path__ + "static/media/elering.b3ccb266.svg";